import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const BookkeepingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-5xl md:text-6xl font-bold text-[#3E2723] mb-6 border-b-2 border-dotted border-gray-300 pb-6">
            Book-keeping Services
          </h1>
          <h2 className="text-2xl text-gray-700 mb-8">
            We offer book-keeping services that scales with you:
          </h2>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          
          {/* Services List */}
          <div className="mb-16">
            <div className="space-y-4">
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
                <p className="text-gray-700 text-lg">Daily/ weekly transaction recording</p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
                <p className="text-gray-700 text-lg">Bank/ Credit card reconciliations</p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
                <p className="text-gray-700 text-lg">Accounts Receivable/ Payable Reconciliations and Management</p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
                <p className="text-gray-700 text-lg">Month-end close and MIS Reporting</p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
                <p className="text-gray-700 text-lg">Audit ready documentation</p>
              </div>
            </div>
          </div>

          {/* Tech Platforms */}
          <div className="mb-16">
            <p className="text-gray-700 text-lg mb-4">Our Tech Platforms include:</p>
            <div className="ml-8 space-y-2">
              <p className="text-gray-700 text-lg">i. Xero</p>
              <p className="text-gray-700 text-lg">ii. QuickBooks/ Zoho Books</p>
              <p className="text-gray-700 text-lg">iii. Any other as may be required</p>
            </div>
          </div>

          {/* Transition and Onboarding Section */}
          <div className="mb-16 bg-stone-50 rounded-lg p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-2 border-dotted border-gray-300 pb-4">
              Transition and Onboarding
            </h2>
            <p className="text-gray-700 text-lg mb-8">
              Our white-glove migration approach is designed to deliver continuity, control, and confidence from day one.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0 font-bold">•</span>
                <p className="text-gray-700 text-lg">
                  <span className="font-bold">Current-state assessment:</span> Deep-dive into existing books, workflows, systems, and pain points to establish a clear baseline and identify risk areas before transition.
                </p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0 font-bold">•</span>
                <p className="text-gray-700 text-lg">
                  <span className="font-bold">Data clean-up (where required):</span> Targeted clean-up of historical data, reconciliations, and open items to ensure accuracy, consistency, and audit-ready books from day one.
                </p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0 font-bold">•</span>
                <p className="text-gray-700 text-lg">
                  <span className="font-bold">SOP alignment & process design:</span> Alignment of workflows, controls, and reporting cadence with client expectations, US GAAP requirements, and internally established policies.
                </p>
              </div>
              <div className="flex items-start">
                <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0 font-bold">•</span>
                <p className="text-gray-700 text-lg">
                  <span className="font-bold">Parallel run & stabilization:</span> Dual-run period with existing processes to validate outputs, fine-tune handoffs, and ensure a smooth, disruption-free transition to steady state.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-[#3E2723] rounded-lg p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">
              Ready to streamline your bookkeeping?
            </h2>
            <p className="text-stone-200 mb-8 text-lg">
              Let us handle your books while you focus on growing your business.
            </p>
            <a href="mailto:hello@trueledger.com?subject=Bookkeeping%20Services%20Inquiry&body=Hi%20Trueledger%20Team,%0A%0AI%20am%20interested%20in%20your%20bookkeeping%20services.%0A%0AThank%20you.">
              <Button className="bg-white text-[#3E2723] hover:bg-stone-100 px-10 py-6 text-lg shadow-lg">
                Get Started Today
              </Button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BookkeepingPage;
